function isFloat(n){
    return Number(n) === n && n % 1 !== 0;
}

const NewSale = (props) => {

  const postDetails = props?.postDetails;
  const totalCharLength = postDetails.industryName.length;

  let maxWidth = '15vw'
  if(totalCharLength > 15 && totalCharLength <= 25) {
    maxWidth = '20vw';
  } else if(totalCharLength > 25) {
    maxWidth = '25vw';
  }

  let formattedAmount = `$${postDetails.amount}`;
  if(isFloat(postDetails.amount)) {
    formattedAmount = `$${postDetails.amount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
  }

  if(postDetails) {
    return <>
        <h2 className="sale-amount">
          {formattedAmount}
        </h2>

        <h2 className="text-center post-type-box" style={{ maxWidth: maxWidth }}>
          {
            postDetails.industryPictureUrl && <img
            style={{ marginRight: '10px' }}
            alt={postDetails.industryName}
            src={postDetails.industryPictureUrl}
            height="30"/>
        }
          {postDetails.industryName}
        </h2>
  </>
  } else {
    return null;
  }

}

export default NewSale;
